import createElement from './createElement';
import api from '../core/utils/api';
import handleError from '../core/utils/handleError';
// Global helpers
import renderText from './renderText';
// Views
import pagination from '../visual-components/pagination';
import condolenceCard from './rememberMe-condolence-card';
// Visual component wrapper
var rememberMeCondolences = function (config, section, condolences, personId) {
    var _a;
    var condolenceWrapper = createElement('div');
    var renderCondolences = function (data) {
        var wrap = condolenceWrapper.querySelector('._msnlq-cd-cw-w');
        wrap.innerHTML = '';
        if (data.length === 0) {
            wrap.innerHTML = "<div class='_msnlq-ercona'>\n                ".concat(renderText('rememberMe.condolences.noentries'), "\n            </div>");
            return;
        }
        data.forEach(function (comment) {
            wrap.appendChild(condolenceCard(config, section, comment, personId));
        });
    };
    var changePage = function (page, callback) {
        return api("/person/".concat(personId, "/interaction?page=").concat(page), [], {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        })
            .then(function (response) {
            if (response && response.json) {
                return response.json();
            }
            return {};
        })
            .then(function (data) {
            if (data.data) {
                renderCondolences(data.data);
                if (callback) {
                    callback();
                }
            }
        })
            .catch(function (error) {
            handleError({
                section: 'rememberMe Condoloences',
                message: "Pagination request failed",
            });
        });
    };
    var render = function () {
        if (condolences.data && condolences.data.length) {
            condolenceWrapper.innerHTML = "\n                <h3> ".concat(renderText('rememberMe.condolence'), " </h3>\n                <div class='_msnlq-cd-cw-w'></div>\n                <div class='_msnlq-cd-cw-pw'></div>\n            ");
            renderCondolences(condolences.data);
            var pagewrap = condolenceWrapper.querySelector('._msnlq-cd-cw-pw');
            pagewrap.appendChild(pagination({
                meta: condolences.meta,
                changePage: changePage,
            }));
        }
    };
    render();
    if ((_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.hideCondolences) {
        return condolenceWrapper;
    }
    return condolenceWrapper;
};
export default rememberMeCondolences;
